import { Link as RouterLink, LinkProps, To } from 'react-router-dom';

import { Button, ButtonProps } from '@oaknorth/component-core-v2';

export type LinkButtonProps = ButtonProps & { to: To; linkProps?: Omit<LinkProps, 'to'> };

/**
 * Wrapper around `IconButton` for when you want it to be an internal link
 *
 * The advantage of this is that it can be correctly disabled by setting the `disabled` prop
 * because the disabled attribute on an HTML anchor (`<a />`) does not disable it.
 */
export function LinkButton({ onClick, children, to, linkProps, ...props }: LinkButtonProps) {
  return (
    <Button
      // Prevent mouse clicks
      pointerEvents={props.disabled ? 'none' : undefined}
      // Prevent keyboard triggering the disabled link
      onClick={(e) => {
        if (props.disabled) {
          e.preventDefault();
        } else {
          onClick?.(e);
        }
      }}
      {...props}
    >
      <RouterLink
        to={to} // Inform keyboard users that it is disabled
        aria-disabled={props.disabled}
        aria-label={props['aria-label']}
        {...linkProps}
      >
        {children}
      </RouterLink>
    </Button>
  );
}
